import {
  generalCategoryContactList,
  generalCategoryContactListLead,
  teamMemberLeadAssignee,
  teamMemberRolesList,
} from 'constants/automation';
import { generateFullName } from 'utils/generateFullNameUtils';

export const formatUserDropdown = ({
  users = [],
  lawftIDs = [],
  isLead = false,
  includesFirmUsers = true,
  includesUserGroups = true,
  includesTeamMembers = true,
  includeContacts = true,
  hideInactive = false,
  includePrimarySecondary = false,
  includeLawftIs = false,
  includeSelectedInactiveUser = false,
  includeSelectedInactiveUserGroup = false,
  selectedItems = [],
}) => {
  let formattedUserGroups = {
    groupLabel: 'Groups',
    code: 'User Groups',
    items: [],
  };
  let formattedFirmUsers = {
    groupLabel: 'Users',
    code: 'Users',
    items: [], //Primary and Billing contact list
  };
  let formattedTeamMemberRoles = {
    groupLabel: isLead ? 'Lead Assignee' : 'Team Member Roles',
    code: 'Team Members',
    items: [...(isLead ? teamMemberLeadAssignee : teamMemberRolesList)],
  };

  let formattedContacts = {
    groupLabel: 'Contacts',
    code: 'Contacts',
    items: [],
  };

  let lawftIds = {
    groupLabel: 'Lawft IDs',
    code: 'Lawft IDs',
    items: [...lawftIDs],
  };

  if (includePrimarySecondary) {
    formattedFirmUsers.items = [...(isLead ? generalCategoryContactListLead : generalCategoryContactList)];
  }

  if (users?.length) {
    users.forEach((user) => {
      if (user?.res_type === 'user') {
        if (user?.status !== 'ACTIVE' && hideInactive) {
          // Include inactive user if the flag is enabled and the user is in selectedItems
          const isSelected = selectedItems.some((item) => item?.value === user?.firm_user_id);
          if (!includeSelectedInactiveUser || !isSelected) {
            return;
          }
        }
        formattedFirmUsers.items.push({
          label: generateFullName(user) + (user?.status === 'ARCHIVED' ? ' (Inactive)' : ''),
          value: user?.firm_user_id,
          is_confirmed: user?.is_confirmed,
          status: user?.status,
          firm_user_id: user?.firm_user_id,
          res_type: user?.res_type,
        });
      } else if (user?.res_type === 'user-group') {
        if (user?.status === 'ARCHIVED' && hideInactive) {
          // Include archived user group if the flag is enabled and the group is in selectedItems
          const isSelected = selectedItems.some((item) => item?.value === user?.user_group_id);
          if (!includeSelectedInactiveUserGroup || !isSelected) {
            return;
          }
        }
        formattedUserGroups.items.push({
          label: user?.group_name + (user?.status === 'ARCHIVED' ? ' (Inactive)' : ''),
          value: user?.user_group_id,
          res_type: user?.res_type,
          status: user?.status,
        });
      } else if (user?.res_type === 'contact') {
        formattedContacts.items.push(user);
      }
    });
  }

  const result = [];
  if (includesFirmUsers) result.push(formattedFirmUsers);
  if (includesTeamMembers) result.push(formattedTeamMemberRoles);
  if (includesUserGroups) result.push(formattedUserGroups);
  if (includeContacts) result.push(formattedContacts);
  if (includeLawftIs) result.push(lawftIds);
  return result;
};
